export const environment = {
  production: false,
  uat: false,
  staging: true,
  development: false,
  environment: 'staging',
  baseUrl: 'https://stg-submarine-api.tracwater.online',
  portalId: '69e710b0f2c26debedc9b848',
  portalTypeId: '689596b618f8a8985a2aeb91'
};
